export default __webpack_public_path__ + "static/artists3-a17ee85523ef0c80defcbb0baa963389.jpg";